import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
} from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';
import { TaxListInfoListing } from '@products/types/tax-list-info.type';
import { getDate, getMomentLocaleFormat } from '@utils/text/date-utils';

@Component({
  selector: 'ft-tax-list-info-print',
  templateUrl: './tax-list-info-print.component.html',
  styleUrls: ['./tax-list-info-print.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaxListInfoPrintComponent implements AfterViewInit {
  @Input() printableRecords: TaxListInfoListing[];
  @Input() printWindow = false;
  todayDate = getDate(new Date().toLocaleDateString(), getMomentLocaleFormat());
  constructor(@Inject(WINDOW) readonly windowRef: Window) {}

  ngAfterViewInit(): void {
    if (this.printWindow) {
      this.windowRef.print();
    }
  }
}
